module.exports = __webpack_public_path__ + "static/media/corporate-services-img92.823da5f3.jpg";